/* LOUNGE CREW: theme.js */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const OH = window.OH || {};
  const root = (OH.routes && OH.routes.root) || '/';

  const toast = (msg) => {
    const t = $('#toast'); if (!t) return;
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(() => t.classList.remove('is-on'), 2600);
  };

  /* ---------- overlays ---------- */
  let lastFocus = null;
  const openLayer = (id) => {
    const el = document.getElementById(id); if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('lock');
    const f = el.querySelector('input:not([type=hidden]),button,a'); if (f) setTimeout(() => f.focus({ preventScroll: true }), 60);
  };
  const closeLayer = (el) => {
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open,.srch.is-open,.modal.is-open,.viewer.is-open')) document.documentElement.classList.remove('lock');
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  };
  document.addEventListener('click', (e) => {
    const op = e.target.closest('[data-open]');
    if (op) {
      const id = op.getAttribute('data-open');
      if (id === 'cart' && document.body.classList.contains('t-cart')) return;
      e.preventDefault(); $$('.drawer.is-open,.srch.is-open').forEach(closeLayer); openLayer(id); return;
    }
    const cl = e.target.closest('[data-close]');
    if (cl) { const layer = cl.closest('.drawer,.srch,.modal'); if (layer) closeLayer(layer); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('.drawer.is-open,.srch.is-open,.modal.is-open').forEach(closeLayer);
  });

  /* ---------- header ---------- */
  const hdr = $('[data-header]');
  if (hdr) {
    const overlay = hdr.classList.contains('hdr--overlay');
    const ann = document.querySelector('.announce');
    const setAnn = () => document.documentElement.style.setProperty('--ann-h', (ann ? ann.offsetHeight : 0) + 'px');
    setAnn(); window.addEventListener('resize', setAnn);
    const onScroll = () => { if (overlay) { hdr.classList.toggle('is-solid', window.scrollY > 40); hdr.style.setProperty('--hdr-top', Math.max(0, (ann ? ann.offsetHeight : 0) - window.scrollY) + 'px'); } };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    $$('[data-mega]', hdr).forEach((item) => {
      const btn = $('button', item); let t;
      const open = () => { clearTimeout(t); $$('[data-mega].is-open', hdr).forEach(i => i !== item && i.classList.remove('is-open')); item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); if (overlay) hdr.classList.add('is-solid'); };
      const close = () => { t = setTimeout(() => { item.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); onScroll(); }, 120); };
      item.addEventListener('mouseenter', open); item.addEventListener('mouseleave', close);
      btn.addEventListener('click', () => item.classList.contains('is-open') ? (item.classList.remove('is-open'), onScroll()) : open());
      item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) close(); });
    });
  }

  /* ---------- money ---------- */
  const money = (cents) => {
    const fmt = OH.moneyFormat || 'R$ {{amount_with_comma_separator}}';
    const v = (cents / 100).toFixed(2);
    const [i, d] = v.split('.');
    const withDot = i.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const withComma = i.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: `${withComma}.${d}`, amount_no_decimals: withComma, amount_with_comma_separator: `${withDot},${d}`, amount_no_decimals_with_comma_separator: withDot
    }[k] || `${withDot},${d}`));
  };

  /* ---------- cart ---------- */
  const setCount = (n) => {
    $$('[data-cart-count]').forEach(el => { el.textContent = n; el.hidden = n === 0; });
    $$('[data-cart-count-text]').forEach(el => el.textContent = `(${n})`);
  };
  /* A sacola vem pronta na MESMA resposta do adicionar/alterar (sections=cart-live). Antes disso, a gaveta já abre
     COM a peça desenhada aqui (foto já baixada, nome, variante, preço, subtotal, contagem e faixa de desconto);
     a resposta do servidor só confirma e substitui, sem piscar. */
  const aplicarSacola = (html) => {
    if (typeof html !== 'string') return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    // mantém o "Completa o look" que já está na tela (sem trocar as peças nem baixar fotos de novo),
    // desde que nenhuma sugestão tenha entrado na sacola
    const sec = doc.querySelector('.shopify-section') || doc.body;
    const naSacola = new Set([...sec.querySelectorAll('.citem[data-pid]')].map(x => x.dataset.pid));
    const upAtual = $('#cart [data-cart-root] .cartd__up'), upNovo = sec.querySelector('.cartd__up');
    if (upAtual && upNovo && ![...upAtual.querySelectorAll('[data-pid]')].some(x => naSacola.has(x.dataset.pid))) upNovo.replaceWith(upAtual.cloneNode(true));
    const inner = sec.innerHTML;
    $$('[data-cart-root],[data-cart-root-page]').forEach(el => { el.innerHTML = inner; el.classList.remove('is-carregando'); });
    const n = doc.querySelector('[data-live-count]'); if (n) setCount(Number(n.textContent) || 0);
  };
  const refreshCart = async () => {
    const r = await fetch(`${root}?sections=cart-live`, { headers: { Accept: 'application/json' } });
    const j = await r.json(); aplicarSacola(j['cart-live']);
  };
  const carregando = (on) => $$('[data-cart-root],[data-cart-root-page]').forEach(el => el.classList.toggle('is-carregando', on));
  const escH = (t) => String(t).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const ICO = { minus: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M5 12h14"/></svg>', plus: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 5v14M5 12h14"/></svg>' };
  const sacolaOtimista = (info) => {
    const box = $('#cart [data-cart-root]'); if (!box || !info) return false;
    const meta = $('[data-live-count]', box);
    const n0 = meta ? Number(meta.textContent) || 0 : 0, bruto0 = meta ? Number(meta.dataset.bruto || meta.dataset.total) || 0 : 0;
    const t1 = meta ? Number(meta.dataset.t1) || 2 : 2, t2 = meta ? Number(meta.dataset.t2) || 3 : 3, p1 = meta ? meta.dataset.p1 || 10 : 10, p2 = meta ? meta.dataset.p2 || 15 : 15;
    const n = n0 + 1, bruto = bruto0 + info.price;
    const pct = n >= t2 ? Number(p2) : n >= t1 ? Number(p1) : 0; const desc = Math.floor(bruto * pct / 100)   /* a Shopify arredonda o desconto para baixo */, tot = bruto - desc;
    const ja = $$('.citem', box).find(li => (li.dataset.key || '').split(':')[0] === String(info.id));
    if (ja) {
      const q = $('.qty span', ja); const qn = (Number(q && q.textContent) || 1) + 1; if (q) q.textContent = qn;
      const pr = $('.citem__price span', ja); if (pr) pr.textContent = money(info.price * qn);
    } else {
      const li = `<li class="citem" data-key="${info.id}:novo" data-pid="${info.pid || ''}"><a href="${escH(info.url)}" class="citem__img">${info.img ? `<img src="${escH(info.img)}" alt="" width="120" height="150" decoding="async">` : ''}</a>
        <div class="citem__info"><a href="${escH(info.url)}" class="citem__title">${escH(info.title)}</a>${info.variant ? `<p class="citem__var">${escH(info.variant)}</p>` : ''}
        <div class="citem__row"><div class="qty"><button type="button" aria-label="Diminuir" disabled>${ICO.minus}</button><span>1</span><button type="button" aria-label="Aumentar" disabled>${ICO.plus}</button></div>
        <div class="citem__price"><span>${money(info.price)}</span></div></div><button type="button" class="citem__rm link-u small" disabled>Remover</button></div></li>`;
      let ul = $('.cartd__items', box);
      if (!ul) {   // sacola vazia: monta o esqueleto (faixa, lista e rodapé)
        box.innerHTML = `<span data-live-count data-total="0" data-bruto="0" data-t1="${t1}" data-t2="${t2}" data-p1="${p1}" data-p2="${p2}" hidden>0</span><div class="cartd__tier"><p></p><div class="meter"><span></span></div></div><ul class="cartd__items"></ul>
          <div class="cartd__foot"><div class="cartd__sum"><span>Subtotal</span><strong></strong></div><p class="small muted">Frete calculado no checkout pelo seu CEP.</p>
          <a href="/cart?view=checkout" class="btn btn--dark btn--full" data-finalizar>Finalizar compra</a><a href="/cart" class="link-u small cartd__view">Ver sacola completa</a></div>`;
        ul = $('.cartd__items', box);
      }
      ul.insertAdjacentHTML('afterbegin', li);   // o servidor lista a peça nova primeiro
    }
    // "Completa o look" já na abertura: usa o modelo da página (fotos pré-baixadas), sem as peças da sacola
    const noCarrinho = new Set([...$$('.citem[data-pid]', box)].map(x => x.dataset.pid)); if (info.pid) noCarrinho.add(String(info.pid));
    let up = $('.cartd__up', box);
    if (up) $$('.upcard[data-pid]', up).forEach(x => { if (noCarrinho.has(x.dataset.pid)) x.remove(); });
    const modelo = $('[data-up-modelo]');
    if (modelo) {
      if (!up) { const ft = $('.cartd__foot', box); if (ft) { ft.insertAdjacentHTML('beforebegin', '<div class="cartd__up"><p class="eyebrow">Completa o look</p><div class="cartd__up-row"></div></div>'); up = $('.cartd__up', box); } }
      const row = up && $('.cartd__up-row', up);
      if (row) {
        const tem = new Set([...$$('[data-pid]', row)].map(x => x.dataset.pid));
        for (const c of modelo.content.querySelectorAll('.upcard')) {
          if (row.children.length >= 4) break;
          if (noCarrinho.has(c.dataset.pid) || tem.has(c.dataset.pid)) continue;
          row.appendChild(c.cloneNode(true)); tem.add(c.dataset.pid);
        }
      }
    }
    const m2 = $('[data-live-count]', box); if (m2) { m2.textContent = n; m2.dataset.total = tot; m2.dataset.bruto = bruto; }
    // desconto progressivo (Leve 2: 10%, Leve 3: 15%) na mesma linha que o servidor mostra
    const foot = $('.cartd__foot', box);
    if (foot) {
      $$('.cartd__disc', foot).forEach(x => x.remove());
      if (pct) foot.insertAdjacentHTML('afterbegin', `<div class="cartd__disc"><span>Leve ${n >= t2 ? t2 : t1} peças: ${pct}% OFF</span><span>−${money(desc)}</span></div>`);
    }
    const sum = $('.cartd__sum strong', box); if (sum) sum.textContent = money(tot);
    const tp = $('.cartd__tier > p', box), mt = $('.cartd__tier .meter span', box);
    if (tp) {
      if (n >= t2) tp.innerHTML = `<strong>${p2}% OFF liberado.</strong> O desconto aparece no checkout.`;
      else if (n >= t1) { const f = t2 - n; tp.innerHTML = `<strong>${p1}% OFF liberado.</strong> Mais ${f} peça${f > 1 ? 's' : ''} e vira ${p2}%.`; }
      else { const f = t1 - n; tp.innerHTML = `Adicione mais ${f} peça${f > 1 ? 's' : ''} e ganhe <strong>${p1}% OFF</strong> automático.`; }
    }
    if (mt) mt.style.width = Math.min(100, Math.floor(n * 100 / t2)) + '%';
    setCount(n);
    return true;
  };
  const addToCart = async (id, qty = 1, btn, info) => {
    if (btn) btn.setAttribute('aria-busy', 'true');
    const naPaginaSacola = document.body.classList.contains('t-cart');
    let otimista = false;
    if (!naPaginaSacola) {
      try { otimista = qty === 1 && sacolaOtimista(info); } catch (e) { otimista = false; }
      openLayer('cart'); if (!otimista) carregando(true);
    }
    try {
      const r = await fetch(`${OH.routes.cartAdd}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }], sections: 'cart-live', sections_url: location.pathname }) });
      const j = await r.json();
      if (!r.ok) {
        carregando(false); refreshCart().catch(() => {}); const d = document.getElementById('cart'); if (d && !naPaginaSacola) closeLayer(d);
        toast(j.description || 'Não foi possível adicionar.'); return;
      }
      if (j.sections && j.sections['cart-live']) aplicarSacola(j.sections['cart-live']); else await refreshCart();
      if (naPaginaSacola) toast('Adicionado à sacola');
    } catch (e) { carregando(false); refreshCart().catch(() => {}); toast('Erro de conexão. Tente de novo.'); }
    finally { if (btn) btn.removeAttribute('aria-busy'); }
  };
  document.addEventListener('click', async (e) => {
    const ch = e.target.closest('[data-change]');
    if (ch) {
      const item = ch.closest('[data-key]'); if (!item) return;
      item.style.opacity = '.5';
      try {
        const r = await fetch(`${OH.routes.cartChange}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: item.dataset.key, quantity: Number(ch.dataset.change), sections: 'cart-live', sections_url: location.pathname }) });
        const j = await r.json();
        if (j.sections && j.sections['cart-live']) aplicarSacola(j.sections['cart-live']); else refreshCart();
      } catch (err) { refreshCart(); }
    }
  });

  /* ---------- quick add ---------- */
  document.addEventListener('click', (e) => {
    const tog = e.target.closest('[data-quick-toggle]');
    if (tog) { const card = tog.closest('[data-pcard]'); $$('.pcard.is-quick').forEach(c => c !== card && c.classList.remove('is-quick')); card.classList.toggle('is-quick'); return; }
    const qa = e.target.closest('[data-quick-add]');
    if (qa) { e.preventDefault(); const card = qa.closest('[data-pcard]'); if (card) card.classList.remove('is-quick'); addToCart(qa.dataset.quickAdd, 1, qa); return; }
    if (!e.target.closest('.pcard__sizes')) $$('.pcard.is-quick').forEach(c => c.classList.remove('is-quick'));
  });

  /* ---------- hero live feed ---------- */
  const live = $('[data-live]');
  if (live) {
    const items = $$('.live__item', live); let i = 0;
    const stamp = (el, k) => { const t = el.querySelector('time'); if (!t) return; const d = new Date(Date.now() - (k * 7 + 2) * 60000); t.textContent = d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }); };
    items.forEach(stamp);
    if (items.length > 1) setInterval(() => { items[i].classList.remove('is-on'); i = (i + 1) % items.length; stamp(items[i], 0); items[i].classList.add('is-on'); }, 3800);
  }

  /* ---------- banner em slides ---------- */
  const hs = $('[data-hs]');
  if (hs) {
    const slides = $$('[data-slide]', hs), bars = $$('.hs__bar', hs), cur = $('[data-hs-cur]', hs);
    const DUR = 6500; let i = 0, timer = null, left = DUR, started = 0;
    hs.style.setProperty('--hs-dur', DUR + 'ms');
    const show = (k) => {
      k = (k + slides.length) % slides.length;
      slides.forEach((s, n) => { s.classList.toggle('is-on', n === k); s.setAttribute('aria-hidden', n !== k); });
      bars.forEach((b, n) => { b.classList.remove('is-on'); b.classList.toggle('is-done', n < k); });
      void bars[k].offsetWidth; bars[k].classList.add('is-on');
      const lazy = slides[k].querySelector('img[loading="lazy"]'); if (lazy) lazy.loading = 'eager';
      if (cur) cur.textContent = String(k + 1).padStart(2, '0');
      i = k; left = DUR; schedule();
    };
    const schedule = () => { clearTimeout(timer); started = Date.now(); timer = setTimeout(() => show(i + 1), left); };
    const pause = () => { if (hs.classList.contains('is-paused')) return; hs.classList.add('is-paused'); clearTimeout(timer); left -= Date.now() - started; };
    const resume = () => { if (!hs.classList.contains('is-paused')) return; hs.classList.remove('is-paused'); schedule(); };
    bars.forEach(b => b.addEventListener('click', () => { hs.classList.remove('is-paused'); show(Number(b.dataset.go)); }));
    if (matchMedia('(hover:hover)').matches) { hs.addEventListener('mouseenter', pause); hs.addEventListener('mouseleave', resume); }
    let x0 = null, y0 = null;
    hs.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    hs.addEventListener('touchend', (e) => {
      if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) show(i + (dx < 0 ? 1 : -1)); x0 = null;
    });
    document.addEventListener('visibilitychange', () => document.hidden ? pause() : resume());
    if (slides.length > 1) show(0);
  }

  /* ---------- índice de frases ---------- */
  const wall = $('[data-wall]');
  if (wall) {
    const list = $('[data-wall-words]', wall), peek = $('[data-wall-peek]', wall);
    const pImg = $('[data-peek-img]', wall), pG = $('[data-peek-g]', wall), pP = $('[data-peek-p]', wall);
    let raf = null, mx = 0, my = 0;
    const move = () => { raf = null; const w = 150, h = 240; let x = mx + 22, y = my - h / 2; if (x + w > innerWidth - 12) x = mx - w - 22; y = Math.max(12, Math.min(innerHeight - h - 12, y)); peek.style.transform = `translate3d(${x}px,${y}px,0)`; };
    list.addEventListener('mousemove', (e) => { mx = e.clientX; my = e.clientY; if (!raf) raf = requestAnimationFrame(move); });
    $$('.wall__w', list).forEach((a) => {
      a.addEventListener('mouseenter', () => { if (!a.dataset.img) return; if (pImg.src !== a.dataset.img) pImg.src = a.dataset.img; pG.textContent = a.dataset.g; pP.textContent = a.dataset.price; peek.classList.add('is-on'); });
      a.addEventListener('mouseleave', () => peek.classList.remove('is-on'));
    });
    $$('[data-wmood]', wall).forEach((b) => b.addEventListener('click', () => {
      $$('[data-wmood]', wall).forEach(x => x.classList.toggle('is-on', x === b));
      const m = b.dataset.wmood;
      $$('.idx__i', list).forEach(li => { const hit = m === 'all' || li.dataset.mood === m; li.classList.toggle('is-out', !hit); li.classList.toggle('is-shown', m !== 'all' && hit); });
    }));
  }

  /* ---------- rails ---------- */
  $$('[data-rail]').forEach((rail) => {
    const sec = rail.closest('section');
    const step = () => (rail.querySelector('.rail__cell')?.getBoundingClientRect().width || 300) + 18;
    sec?.querySelector('[data-rail-prev]')?.addEventListener('click', () => rail.scrollBy({ left: -step() * 2, behavior: 'smooth' }));
    sec?.querySelector('[data-rail-next]')?.addEventListener('click', () => rail.scrollBy({ left: step() * 2, behavior: 'smooth' }));
  });

  /* ---------- tabs ---------- */
  $$('[data-tabs]').forEach((t) => {
    $$('[data-tab]', t).forEach((b) => b.addEventListener('click', () => {
      $$('[data-tab]', t).forEach(x => { x.classList.toggle('is-on', x === b); x.setAttribute('aria-selected', x === b); });
      $$('[data-panel]', t).forEach(p => p.hidden = p.dataset.panel !== b.dataset.tab);
    }));
  });

  /* ---------- roulette ---------- */
  const roul = $('.roul');
  if (roul) {
    let data = []; try { data = JSON.parse($('[data-roul-data]', roul).textContent); } catch (e) {}
    let mood = 'all'; let last = -1;
    const card = $('[data-roul-link]', roul), img = $('[data-roul-img]', roul);
    const show = (p) => {
      if (!p) return;
      card.classList.add('is-spinning');
      /* Só troca a foto depois que a nova carregou: no 4G a troca imediata deixava o cartão em branco. */
      const pre = new Image(); let feito = false;
      const trocar = () => {
        if (feito) return; feito = true;
        card.href = p.u; img.src = p.i; img.alt = p.q;
        $('[data-roul-q]', roul).textContent = `“${p.q}”`; $('[data-roul-g]', roul).textContent = p.g; $('[data-roul-p]', roul).textContent = p.p;
        card.classList.remove('is-spinning');
      };
      pre.onload = pre.onerror = () => setTimeout(trocar, 200);
      setTimeout(trocar, 4000);
      pre.src = p.i;
    };
    const spin = () => {
      const pool = data.filter(d => mood === 'all' || d.m === mood); if (!pool.length) return;
      let k; do { k = Math.floor(Math.random() * pool.length); } while (pool.length > 1 && k === last); last = k; show(pool[k]);
    };
    $$('[data-mood]', roul).forEach(b => b.addEventListener('click', () => { $$('[data-mood]', roul).forEach(x => x.classList.toggle('is-on', x === b)); mood = b.dataset.mood; last = -1; spin(); }));
    $('[data-spin]', roul).addEventListener('click', spin);
    if (!img.getAttribute('src')) spin();
  }

  /* ---------- predictive search (overlay + busca da coleção) ---------- */
  $$('[data-predictive]').forEach((pInput) => {
    const box = pInput.closest('[data-psearch]') || pInput.closest('.srch') || document;
    const out = $('[data-results]', box), hints = $('[data-hints]', box); let t, ctrl;
    if (!out) return;
    pInput.addEventListener('input', () => {
      clearTimeout(t); const q = pInput.value.trim();
      if (q.length < 2) { out.innerHTML = ''; if (hints) hints.hidden = false; return; }
      t = setTimeout(async () => {
        ctrl?.abort(); ctrl = new AbortController();
        try {
          const r = await fetch(`${OH.routes.predictive}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&section_id=predictive-search`, { signal: ctrl.signal });
          const html = await r.text(); const doc = new DOMParser().parseFromString(html, 'text/html');
          out.innerHTML = doc.querySelector('.shopify-section')?.innerHTML || html; if (hints) hints.hidden = true;
        } catch (e) {}
      }, 220);
    });
  });
  const ps = $('[data-psearch]');
  if (ps && new URLSearchParams(location.search).get('buscar') === '1') {
    requestAnimationFrame(() => {
      ps.scrollIntoView({ block: 'start' });
      if (matchMedia('(hover:hover)').matches) $('[data-predictive]', ps).focus({ preventScroll: true });
    });
  }

  /* ---------- collection: sort, load more, filters ---------- */
  const sort = $('[data-sort]');
  if (sort) sort.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); location.href = u.toString(); });
  const ff = $('[data-filter-form]');
  if (ff) ff.addEventListener('submit', (e) => {
    e.preventDefault(); const u = new URL(location.href); const fd = new FormData(ff);
    [...u.searchParams.keys()].forEach(k => { if (k.startsWith('filter.') || k === 'page') u.searchParams.delete(k); });
    for (const [k, v] of fd.entries()) { if (v !== '') u.searchParams.append(k, v); }
    location.href = u.toString();
  });
  document.addEventListener('click', async (e) => {
    const lm = e.target.closest('[data-load-more]'); if (!lm) return;
    e.preventDefault(); lm.textContent = 'Carregando…';
    const r = await fetch(lm.href); const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
    const grid = $('[data-grid]'); const newGrid = doc.querySelector('[data-grid]');
    if (grid && newGrid) $$('[data-pcard]', newGrid).forEach(c => grid.appendChild(c));
    const next = doc.querySelector('[data-load-more]'); const wrap = lm.closest('.coll__more');
    const info = doc.querySelector('.coll__more .small');
    if (next) { lm.href = next.href; lm.textContent = 'Carregar mais peças'; if (info && wrap.querySelector('.small')) wrap.querySelector('.small').textContent = info.textContent; }
    else wrap.remove();
    history.replaceState(null, '', lm.href);
  });

  /* ---------- product page ---------- */
  const pdp = $('[data-pdp]');
  if (pdp) {
    const product = JSON.parse($('[data-product-json]', pdp).textContent);
    const form = $('[data-product-form]', pdp);
    const idInput = $('[data-variant-id]', pdp);
    const atc = $('[data-atc]', pdp), atcLabel = $('[data-atc-label]', pdp);
    const priceEl = $('[data-price]', pdp);
    const list = $('[data-media-list]', pdp); const dots = $('[data-dots]', pdp);
    const colorIndex = product.options.findIndex(o => (o.name || o) === 'Cor');

    const selected = () => $$('fieldset.opt', pdp).map(fs => { const c = $('input:checked', fs); return c ? c.value : null; });
    const current = () => { const s = selected(); return product.variants.find(v => v.options.every((o, i) => o === s[i])); };

    const renderDots = () => {
      if (!dots) return; const vis = $$('.pdp__media:not(.is-hidden)', list);
      dots.innerHTML = vis.map((_, i) => `<button type="button" aria-label="Imagem ${i + 1}" class="${i === 0 ? 'is-on' : ''}"></button>`).join('');
      $$('button', dots).forEach((b, i) => b.addEventListener('click', () => vis[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' })));
    };
    list.addEventListener('scroll', () => {
      const vis = $$('.pdp__media:not(.is-hidden)', list); const w = list.clientWidth || 1;
      const idx = Math.round(list.scrollLeft / w); $$('button', dots).forEach((b, i) => b.classList.toggle('is-on', i === idx));
    }, { passive: true });

    /* ---- visualizador da foto (clique na imagem) ---------------------------------- */
    // no toque a galeria já é arrastável; o visualizador é para quem tem mouse
    const fino = window.matchMedia('(hover:hover) and (pointer:fine)');
    let vw = null, vwI = 0, vwItens = [];
    const vwMontar = () => {
      if (vw) return vw;
      vw = document.createElement('div');
      vw.className = 'viewer';
      vw.innerHTML = '<div class="viewer__palco" data-palco>' +
        '<img class="viewer__img" alt="" data-vimg></div>' +
        '<button type="button" class="viewer__x" aria-label="Fechar" data-vx>&times;</button>' +
        '<button type="button" class="viewer__nav viewer__nav--ant" aria-label="Foto anterior" data-vant>&#8249;</button>' +
        '<button type="button" class="viewer__nav viewer__nav--prox" aria-label="Próxima foto" data-vprox>&#8250;</button>' +
        '<p class="viewer__conta" data-vconta></p>';
      document.body.appendChild(vw);
      const img = $('[data-vimg]', vw);
      $('[data-vx]', vw).addEventListener('click', vwFechar);
      $('[data-vant]', vw).addEventListener('click', () => vwIr(-1));
      $('[data-vprox]', vw).addEventListener('click', () => vwIr(1));
      $('[data-palco]', vw).addEventListener('click', (e) => { if (e.target === img) vwLupa(e); else vwFechar(); });
      img.addEventListener('mousemove', (e) => {
        if (!img.classList.contains('is-zoom')) return;
        const r = img.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
      return vw;
    };
    const vwLupa = (e) => {
      const img = $('[data-vimg]', vw);
      const r = img.getBoundingClientRect();
      img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      img.classList.toggle('is-zoom');
    };
    const vwMostrar = () => {
      const fig = vwItens[vwI]; if (!fig) return;
      const img = $('[data-vimg]', vw), dentro = $('img', fig);
      img.classList.remove('is-zoom'); img.style.transformOrigin = 'center';
      img.src = fig.dataset.zoom || (dentro && dentro.currentSrc) || '';
      img.alt = fig.dataset.legenda || (dentro ? dentro.alt : '');
      const varias = vwItens.length > 1;
      $('[data-vant]', vw).hidden = !varias; $('[data-vprox]', vw).hidden = !varias;
      $('[data-vconta]', vw).innerHTML = varias ? '<b>' + (vwI + 1) + '</b> / ' + vwItens.length : '';
    };
    const vwIr = (d) => { vwI = (vwI + d + vwItens.length) % vwItens.length; vwMostrar(); };
    const vwAbrir = (fig) => {
      vwItens = $$('.pdp__media:not(.is-hidden)', list);
      vwI = Math.max(0, vwItens.indexOf(fig));
      vwMontar(); vwMostrar();
      vw.classList.add('is-open');
      document.documentElement.classList.add('lock');
      $('[data-vx]', vw).focus({ preventScroll: true });
    };
    function vwFechar() {
      if (!vw) return;
      vw.classList.remove('is-open');
      document.documentElement.classList.remove('lock');
    }
    list.addEventListener('click', (e) => {
      if (!fino.matches) return;
      const fig = e.target.closest('.pdp__media'); if (!fig) return;
      vwAbrir(fig);
    });
    document.addEventListener('keydown', (e) => {
      if (!vw || !vw.classList.contains('is-open')) return;
      if (e.key === 'Escape') { e.stopPropagation(); vwFechar(); }
      if (e.key === 'ArrowRight') vwIr(1);
      if (e.key === 'ArrowLeft') vwIr(-1);
    });

    const fitIndex = product.options.findIndex(o => (o.name || o) === 'Caimento');
    // o caimento escolhido vem primeiro; o outro fica logo ao lado para comparar
    const fitFirst = (fit) => (a, b) => (b.dataset.fit === fit) - (a.dataset.fit === fit);
    /* Galeria da cor escolhida: costas (caimento escolhido primeiro), logo depois a FRENTE (a da própria cor, ou a
       frente padrão quando a peça só tem uma) e em seguida as outras cores. Antes a frente sumia ao trocar de cor. */
    const filterMedia = (color, fit) => {
      const items = $$('.pdp__media', list);
      const frentes = items.filter(m => m.classList.contains('is-alt'));
      const costas = items.filter(m => !m.classList.contains('is-alt'));
      const mine = costas.filter(m => m.dataset.color === color);
      if (!mine.length) return;
      if (fit) mine.sort(fitFirst(fit));
      const frente = frentes.find(m => m.dataset.color === color) || frentes[0];
      const rest = costas.filter(m => m.dataset.color !== color);
      if (fit) {                       // outras cores em pares (caimento escolhido primeiro), sem misturar as cores
        const grupos = new Map();
        rest.forEach(m => { if (!grupos.has(m.dataset.color)) grupos.set(m.dataset.color, []); grupos.get(m.dataset.color).push(m); });
        rest.length = 0;
        grupos.forEach(g => rest.push(...g.sort(fitFirst(fit))));
      }
      const escondidas = frentes.filter(m => m !== frente);
      [...mine, ...(frente ? [frente] : []), ...rest, ...escondidas].forEach(m => { m.classList.remove('is-hidden'); list.appendChild(m); });
      escondidas.forEach(m => m.classList.add('is-hidden'));
      const vis = items.length - escondidas.length;
      list.classList.toggle('is-even', (vis - 1) % 2 === 1);
      list.scrollLeft = 0; renderDots();
    };
    const update = () => {
      const v = current(); const s = selected();
      $$('fieldset.opt', pdp).forEach((fs, i) => { const l = $('[data-option-label]', fs); if (l) l.textContent = s[i]; });
      // disponibilidade de tamanhos para a cor atual
      if (colorIndex > -1) {
        $$('fieldset.opt', pdp).forEach((fs, i) => {
          if (i === colorIndex) return;
          $$('input', fs).forEach(inp => {
            const opts = s.slice(); opts[i] = inp.value;
            const vv = product.variants.find(x => x.options.every((o, k) => o === opts[k]));
            inp.closest('label').classList.toggle('is-unavailable', !vv || !vv.available);
          });
        });
        filterMedia(s[colorIndex], fitIndex > -1 ? String(s[fitIndex] || '').toLowerCase() : '');
      }
      if (!v) { atc.disabled = true; atcLabel.textContent = 'Indisponível'; return; }
      idInput.value = v.id; priceEl.textContent = money(v.price);
      atc.disabled = !v.available; atcLabel.textContent = v.available ? `Adicionar à sacola · ${money(v.price)}` : 'Esgotado';
      const sv = $('[data-satc-var]', pdp); if (sv) sv.textContent = `${v.title.replace(/ \/ /g, ' · ')} · ${money(v.price)}`;
      const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
    };
    $$('[data-option]', pdp).forEach(i => i.addEventListener('change', update));
    update();

    /* dados da linha da sacola desenhada na hora; a foto de 240 px (a mesma URL que o servidor devolve) é pré-baixada */
    const fotoSacola = (v) => { const f = (v && v.featured_image && v.featured_image.src) || product.featured_image; if (!f) return ''; const u = (f.startsWith('//') ? 'https:' : '') + f; return u + (u.includes('?') ? '&' : '?') + 'width=240'; };
    const infoLinha = (v) => ({ id: v.id, pid: product.id, price: v.price, title: product.title, url: `/products/${product.handle}?variant=${v.id}`, img: fotoSacola(v),
      variant: (v.title && v.title !== 'Default Title') ? v.title.replace(/ \/ /g, ' · ') : '' });
    const preBaixar = () => { const v = current(); const u = fotoSacola(v); if (u) { const im = new Image(); im.decoding = 'async'; im.src = u; } };
    $$('[data-option]', pdp).forEach(i => i.addEventListener('change', preBaixar));
    (window.requestIdleCallback || ((f) => setTimeout(f, 1200)))(() => {
      preBaixar();
      const md = $('[data-up-modelo]'); if (md) md.content.querySelectorAll('img').forEach(i => { const im = new Image(); im.decoding = 'async'; im.src = i.getAttribute('src'); });
    });
    form.addEventListener('submit', (e) => { e.preventDefault(); const v = current(); if (v && v.available) addToCart(v.id, 1, atc, infoLinha(v)); });

    // sticky atc mobile
    const satc = $('[data-satc]', pdp);
    if (satc && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => { const on = !en.isIntersecting && en.boundingClientRect.top < 0; satc.classList.toggle('is-on', on); satc.setAttribute('aria-hidden', !on); }, { threshold: 0 }).observe(atc);
      $('[data-satc-btn]', satc).addEventListener('click', () => { const v = current(); if (v && v.available) addToCart(v.id, 1, null, infoLinha(v)); else atc.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    }

    $('[data-share]', pdp)?.addEventListener('click', async () => {
      try { if (navigator.share) await navigator.share({ title: document.title, url: location.href }); else { await navigator.clipboard.writeText(location.href); toast('Link copiado'); } } catch (e) {}
    });

    // mesma frase
    const same = $('[data-same]');
    if (same) {
      fetch(same.dataset.url).then(r => r.text()).then(html => {
        const doc = new DOMParser().parseFromString(`<div>${html}</div>`, 'text/html');
        const cards = $$('.cards-item', doc).filter(c => c.dataset.handle !== pdp.dataset.handle);
        if (cards.length) { const g = $('[data-same-grid]', same); cards.slice(0, 4).forEach(c => g.appendChild(c.firstElementChild)); same.hidden = false; }
      }).catch(() => {});
    }
    // recentes
    try {
      const key = 'lc_recent'; const cur = { h: product.handle, t: product.title, i: product.featured_image, p: (product.variants && product.variants[0] ? product.variants[0].price : product.price), u: `/products/${product.handle}` };
      const arr = JSON.parse(localStorage.getItem(key) || '[]').filter(x => x.h !== cur.h); arr.unshift(cur); localStorage.setItem(key, JSON.stringify(arr.slice(0, 12)));
    } catch (e) {}
  }

  /* ---------- recommendations ---------- */
  const recs = $('[data-recs]');
  if (recs && !recs.querySelector('[data-rail]')) {
    fetch(recs.dataset.url).then(r => r.text()).then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html'); const s = doc.querySelector('[data-recs]');
      if (s && s.innerHTML.trim()) {
        recs.innerHTML = s.innerHTML;
        const rail = $('[data-rail]', recs);
        if (rail) {
          const step = () => (rail.querySelector('.rail__cell')?.getBoundingClientRect().width || 300) + 18;
          $('[data-rail-prev]', recs)?.addEventListener('click', () => rail.scrollBy({ left: -step() * 2, behavior: 'smooth' }));
          $('[data-rail-next]', recs)?.addEventListener('click', () => rail.scrollBy({ left: step() * 2, behavior: 'smooth' }));
        }
      }
    }).catch(() => {});
  }

  /* ---------- recently viewed ---------- */
  const rec = $('[data-recent]');
  if (rec) {
    try {
      const here = pdp ? pdp.dataset.handle : null;
      const arr = JSON.parse(localStorage.getItem('lc_recent') || '[]').filter(x => x.h !== here).slice(0, 8);
      if (arr.length >= 2) {
        const esc = (s) => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
        /* A foto e o preço salvos no navegador envelhecem: a peça troca de foto ou sai da loja
           e o endereço antigo vira um "?". Busca cada peça de novo e descarta a que não existe mais. */
        Promise.all(arr.map(x => fetch(`/products/${encodeURIComponent(x.h)}.js`).then(r => r.ok ? r.json() : null).catch(() => null)))
          .then(prods => {
            const vivos = prods.filter(p => p && p.available !== undefined && p.featured_image);
            try { localStorage.setItem('lc_recent', JSON.stringify(JSON.parse(localStorage.getItem('lc_recent') || '[]').filter(x => x.h === here || vivos.some(p => p.handle === x.h)))); } catch (e) {}
            if (vivos.length < 2) return;
            $('[data-recent-row]', rec).innerHTML = vivos.map(p => {
              const q = p.title.split('“').pop().replace('”', ''); const img = p.featured_image.startsWith('//') ? 'https:' + p.featured_image : p.featured_image;
              const preco = p.variants && p.variants[0] ? p.variants[0].price : p.price;
              return `<a class="upcard" href="/products/${esc(p.handle)}"><img src="${esc(img)}${img.includes('?') ? '&' : '?'}width=400" alt="" loading="lazy" decoding="async" width="200" height="250"><span class="serif" style="font-size:17px">“${esc(q)}”</span><small>${money(preco)}</small></a>`;
            }).join('');
            rec.hidden = false;
          });
      }
    } catch (e) {}
  }

  /* ---------- reveal ---------- */
  const rev = $$('[data-reveal]');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((ents) => ents.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { threshold: 0, rootMargin: '0px 0px -8% 0px' });
    rev.forEach(el => io.observe(el));
  } else rev.forEach(el => el.classList.add('is-in'));
})();

/* Foto de hover dos cards: só baixa em aparelho com mouse e quando o card chega
   perto da tela. No celular não existe hover e a segunda foto era peso morto. */
(function () {
  if (!window.matchMedia || !matchMedia('(hover: hover)').matches) return;
  var carregar = function (img) {
    if (!img.dataset.hoverSrcset) return;
    img.srcset = img.dataset.hoverSrcset; img.src = img.dataset.hoverSrc;
    delete img.dataset.hoverSrcset; delete img.dataset.hoverSrc;
  };
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (ents) {
    ents.forEach(function (en) { if (en.isIntersecting) { carregar(en.target); io.unobserve(en.target); } });
  }, { rootMargin: '300px 0px' }) : null;
  var ligar = function (raiz) {
    (raiz.querySelectorAll ? raiz.querySelectorAll('img[data-hover-srcset]') : []).forEach(function (img) { io ? io.observe(img) : carregar(img); });
    if (raiz.matches && raiz.matches('img[data-hover-srcset]')) { io ? io.observe(raiz) : carregar(raiz); }
  };
  ligar(document);
  new MutationObserver(function (ms) { ms.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) ligar(n); }); }); })
    .observe(document.body, { childList: true, subtree: true });
})();

